import React from 'react';
import Scroll from 'react-scroll';

var Link = Scroll.Link;

class Navbar extends React.Component {
	render () {
		return (
			<nav className="navbar navbar--animated-width row u-pv-">
			  <span className="sm-3 sm-center md-2 md-offset-2 col"><Link className="navbar__link u-d--inline-block" to="home" spy={true} smooth={'easeInQuad'} offset={-50} duration={650}>Home</Link></span>
			  <span className="sm-3 sm-center md-2 col"><Link className="navbar__link u-d--inline-block" to="about" spy={true} smooth={'easeInQuad'} offset={-50} duration={650}>About</Link></span>
			  <span className="sm-3 sm-center md-2 col"><Link className="navbar__link u-d--inline-block" to="work" spy={true} smooth={'easeInQuad'} offset={-50} duration={650}>Work</Link></span>
			  <span className="sm-3 sm-center md-2 col"><Link className="navbar__link u-d--inline-block" to="contact" spy={true} smooth={'easeInQuad'} offset={-50} duration={650}>Contact</Link></span>
			</nav>
		)
	}
};

export default Navbar;


// WEBPACK FOOTER //
// ./src/components/Navbar.js